<div class="flex justify-end items-center">
  <img src="/assets/images/Contact Support.png" (click)="openHelpCenterModal()" class="cursor-pointer" #helpCenterBtn>
</div>
